import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as projectdossierQueryKey } from '../hooks/useProjectdossier'
import { patchProjectdossier } from '../services/patchProjectdossier'

export { useUpdateProjectdossier }

const useUpdateProjectdossier = () => {
  const queryClient = useQueryClient()
  const { successAlert, errorAlert } = useAlerts()

  return useMutation({
    mutationFn: patchProjectdossier,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [projectdossierQueryKey, data.projectdossierId],
      })
      successAlert('Projectdossier successvol bijgewerkt')
    },
    onError: (error: any) => {
      errorAlert('Fout bij bijwerken projectdossier', error)
    },
  })
}
